import React, { useState, useEffect, useRef } from "react";
import ProgressBar from "../progressBar/ProgressBar";
import PageHeader from "../../shared/pageHeader/PageHeader";
import ActionFooter from "../../shared/actionFooter/ActionFooter";
import { withTranslation } from "react-i18next";
import HasPermissionTo from "../../common/HasPermissionTo";
import PendingActionClient from "../../shared/clients/PendingActionClient";

const QuickStart = (props) => {
  const [currentTabKey, setCurrentTabKey] = useState(0);
  const [displayActionFooter, setDisplayActionFooter] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const formRef = useRef(null);
  const fileRef = useRef(null);
  const termsAcceptedStatusRef = useRef("");

  useEffect(() => {
    if (props.isNsc) {
      PendingActionClient.getNscPendingActionsNotifications();
    }
  }, []);

  const nextStep = {
    onSuccess: () => {
      setCurrentTabKey(currentTabKey + 1);
      setDisplayActionFooter(true);
    },
    onFailure: () => {},
  };

  const onSubmit = (data) => {
    if (data.reservations) {
      if (data.reservations.length === 0) {
        setErrorMessage("Please select a Model to apply the order deposit.");
      } else {
        continueBoarding(data);
      }
    } else {
      continueBoarding(data);
    }
  };

  const continueBoarding = (data) => {
    setErrorMessage("");
    props.hideOrShow(true, true);
    props.onboardingClient
      .onBoard(props.user, data, props.dealerGroup)
      .then((response) => {
        if (response === "go to dashboard") {
          props.onSave(props.user);
        } else if (response === "go to decline page") {
          props.onDecline();
        } else {
          nextStep.onSuccess();
        }
      })
      .catch((error) => nextStep.onFailure(error))
      .finally(() => props.hideOrShow(false, true));
  };

  const toggleActionFooter = (value) => {
    setDisplayActionFooter(value);
  };

  const updateCurrentObject = (childState) => {
    if (childState.file) {
      fileRef.current = childState.file;
    }
    if (childState.status) {
      termsAcceptedStatusRef.current = childState.status;
    }
  };

  const validateFormInfo = () => {
    const saveBtn = props.progressBarTabs[currentTabKey].saveBtn;
    switch (saveBtn) {
      case "welcome":
        if (props.dealerGroup.length > 0) {
          nextStep.onSuccess();
        }
        break;
      case "uploadFile":
        onSubmit({ file: fileRef.current });
        break;
      case "saveForm":
        formRef.current && formRef.current.submit();
        break;
      case "acceptTermsAndConditions":
        onSubmit({ termsAcceptedStatus: termsAcceptedStatusRef.current });
        break;
      case "savePaymentThreshold":
        formRef.current && formRef.current.submit();
        break;
      default:
    }
  };

  const StepComponent = props.progressBarTabs?.[currentTabKey]?.stepComponent;

  return (
    <div id="quickStart" className="pageWrapper">
      <PageHeader {...props} title={props.t("GeneralEMP.onboarding")} />
      {props.progressBarTabs[currentTabKey].key !== 0 && (
        <HasPermissionTo
          perform={["progressBar:view"]}
          permissions={props.user.permissions.rolePermissions}
          render={() => (
            <ProgressBar
              tabs={props.progressBarTabs}
              currentTab={props.progressBarTabs[currentTabKey]}
              marketId={props.user.market}
            />
          )}
        />
      )}
      {StepComponent && typeof StepComponent === "function" && (
        <StepComponent
          {...props}
          showActionFooter={toggleActionFooter}
          updateParentState={updateCurrentObject}
          onSubmit={onSubmit}
          formRef={formRef}
          errorMessage={errorMessage}
        />
      )}
      {props.progressBarTabs[currentTabKey].name !==
      "ProgressBar.dealer.welcome" ? (
        <ActionFooter
          actionName={props.t(props.progressBarTabs[currentTabKey].actionText)}
          disabled={props.dealerGroup ? props.dealerGroup.length === 0 : false}
          observer={validateFormInfo}
          displayActionFooter={displayActionFooter}
        />
      ) : null}
    </div>
  );
};

export default withTranslation("emp")(QuickStart);
